import React from "react";
import SliderPrincipal from "components/slider/slider";
import ListPrincipal from "components/list/list";
import ListadoPartidosEnvivo from "components/partidos-envivo/listado-partidos-envivo/listado-partidos-envivo";

export default function HomePage() {

  const url = window.location.href;
  const parametros = new URLSearchParams(new URL(url).search);

  // Obten valores específicos de los parámetros
  const valorParametro1 = parametros.get('type');
  const valorParametro2 = parametros.get('url');
  const valorParametro3 = parametros.get('momios');

  const valorParametro4 = parametros.get('league');
  const valorParametro5 = parametros.get('section');
  const valorParametro6 = parametros.get('filter');

  const valorParametro7 = parametros.get('patrocinador');

  return (
    <>
      {valorParametro1 === 'normal' && !valorParametro5
        ? <ListPrincipal url={valorParametro2} flagMomios={valorParametro3} patrocinador={valorParametro7}/>
        : !valorParametro5 && <SliderPrincipal url={valorParametro2} flagMomios={valorParametro3} patrocinador={valorParametro7}/>
      }

      { valorParametro5 === 'partidos-envivo' &&
        <ListadoPartidosEnvivo seccion={valorParametro5} ligaFut={valorParametro4} showFilter={valorParametro6}/>
      }
    </>
  )
}
